import * as React from "react";
import "../../style/fonts.css";
import "./ResetPassword.css";
import translate from "../../translations/i18n";
import CtaButton from "../ctaButton/ctaButton";
class ResetPasswordError extends React.Component<any> {
  render() {
    return (
      <div className="reset-password-cont">
        <div className="reset-password-cont-center">
          <div className="reset-password__headline">
            <div className="TITLE_2">
              {translate("NEW_PASSWORD_WEB_FAILURE_TITLE")}
            </div>
          </div>
          <div className="reset-password__text">
            <div className="REG_TEXT ">
              {translate("NEW_PASSWORD_WEB_FAILURE_TEXT")}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPasswordError;



// WEBPACK FOOTER //
// ./src/components/resetPassword/ResetPasswordError.tsx